import { AxiosResponse } from "axios";
import {
	AddToSendUpdateQueueRequest,
	ClaimSearchRequest,
	PrintSupplierPartsReportRequest,
	RequotePartClaimRequest,
} from "@/main/models/request";
import { Result } from "@/main/models/common/resultResponse";
import {
	ClaimGridItemDetailResponse,
	ClaimGridItemPartResponse,
	ClaimOrdersViewResponse,
	ClaimSearchGridResponse,
	PrintSupplierPartsReportResponse,
	ClaimTooltipViewResponse,
	ClaimItemsToRequoteResponse,
	QuotationsViewResponse,
} from "@/main/models/response";
import { KeyValue } from "@/main/models/common";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class IClaimApi {
	abstract getClaimTooltipData(guidClaim: string): Promise<AxiosResponse<Result<ClaimTooltipViewResponse>>>;
	abstract getItemsToRequote(guidClaim: string): Promise<AxiosResponse<Result<ClaimItemsToRequoteResponse>>>;
	abstract requoteItemsClaim(request: RequotePartClaimRequest): Promise<AxiosResponse<Result<void>>>;
	abstract getQuotationsByGuidClaim(guidClaim: string): Promise<AxiosResponse<Result<QuotationsViewResponse[]>>>;
	abstract getOrdersByGuidClaim(guidClaim: string): Promise<AxiosResponse<Result<ClaimOrdersViewResponse[]>>>;

	abstract searchGrid(request: ClaimSearchRequest): Promise<AxiosResponse<PaginationResponse<ClaimSearchGridResponse>>>;
	abstract getGridItemDetails(guidClaim: string): Promise<AxiosResponse<Result<ClaimGridItemDetailResponse>>>;
	abstract getgridparts(guidClaim: string): Promise<AxiosResponse<Result<ClaimGridItemPartResponse[]>>>;
	abstract requotePartsCancelledBySupplier(request: RequotePartClaimRequest): Promise<AxiosResponse<Result<void>>>;

	abstract addSendUpdateQueue(request: AddToSendUpdateQueueRequest): Promise<AxiosResponse<Result<void>>>;
	abstract getSupplierPartsReportSuppliers(guidClaim: string): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract printSupplierPartsReport(
		request: PrintSupplierPartsReportRequest,
	): Promise<AxiosResponse<Result<PrintSupplierPartsReportResponse>>>;
}
